import { AxiosError } from 'axios';

export enum FireblocksQueryKeys {
  ExecuteTransaction = 'execute_transaction',
  VaultAccounts = 'vault_accounts',
  VaultAccountAssetAddresses = 'vault_account_asset_addresses',
}

// TODO: maybe add more fields here in the future
export type Problem = {
  error: string;
};

export type RequestError = AxiosError<Problem>;

// Local type definitions (previously from @fireblocks/ts-sdk)
export interface VaultAccount {
  id: string;
  name: string;
  hiddenOnUI?: boolean;
  customerRefId?: string;
  autoFuel?: boolean;
  assets?: VaultAsset[];
}

export interface VaultAsset {
  id: string;
  total?: string;
  available?: string;
  pending?: string;
  frozen?: string;
  lockedAmount?: string;
  staked?: string;
}

export interface FireblocksResponse<T> {
  data: T;
  statusCode?: number;
}

export interface VaultAccountsPagedResponse {
  accounts?: VaultAccount[];
  paging?: {
    before?: string;
    after?: string;
  };
  previousUrl?: string;
  nextUrl?: string;
}

export interface PaginatedAddressResponse {
  addresses?: Address[];
  paging?: {
    before?: string;
    after?: string;
  };
}

export interface Address {
  address: string;
  tag?: string;
  legacyAddress?: string;
  type?: string;
}

export interface VaultsApiGetPagedVaultAccountsRequest {
  namePrefix?: string;
  nameSuffix?: string;
  minAmountThreshold?: number;
  assetId?: string;
  orderBy?: string;
  before?: string;
  after?: string;
  limit?: number;
  tagIds?: string[];
}

export interface VaultsApiGetVaultAccountAssetAddressesPaginatedRequest {
  vaultAccountId: string;
  assetId: string;
  before?: string;
  after?: string;
  limit?: number;
}
